import { render, staticRenderFns } from "./recruitdetails.vue?vue&type=template&id=75376951&scoped=true&"
import script from "./recruitdetails.vue?vue&type=script&lang=js&"
export * from "./recruitdetails.vue?vue&type=script&lang=js&"
import style0 from "./recruitdetails.vue?vue&type=style&index=0&id=75376951&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75376951",
  null
  
)

export default component.exports